import { Lightbulb, Megaphone, Award, Lock } from "lucide-react";

/**
 * StickerBook — small row of three badges shown on the elementary
 * dashboard. Locked badges render as muted silhouettes; unlocked badges
 * pop with brand color.
 */
const BADGES = [
  {
    key: "firstIdea",
    title: "First Idea",
    description: "Completed Mission 1",
    icon: Lightbulb,
    bg: "from-yellow-100 to-amber-100",
    ring: "ring-yellow-300",
    iconBg: "bg-yellow-500",
  },
  {
    key: "bravePitch",
    title: "Brave Pitch",
    description: "Completed Mission 8",
    icon: Megaphone,
    bg: "from-orange-100 to-rose-100",
    ring: "ring-orange-300",
    iconBg: "bg-orange-500",
  },
  {
    key: "juniorCEO",
    title: "Junior CEO",
    description: "Completed every mission",
    icon: Award,
    bg: "from-green-100 to-emerald-100",
    ring: "ring-green-300",
    iconBg: "bg-green-500",
  },
];

export default function StickerBook({ unlocked = {}, testId = "jr-sticker-book" }) {
  return (
    <section className="mt-10" data-testid={testId}>
      <div className="flex items-center gap-2 mb-3">
        <Award className="w-5 h-5 text-yellow-600" />
        <h3 className="text-base font-bold text-gray-900 uppercase tracking-wide">
          Sticker Book
        </h3>
        <span className="text-xs text-gray-500 ml-1">
          {Object.values(unlocked).filter(Boolean).length} of {BADGES.length} earned
        </span>
      </div>
      <div className="grid sm:grid-cols-3 gap-4">
        {BADGES.map((b) => {
          const isUnlocked = Boolean(unlocked[b.key]);
          const Icon = isUnlocked ? b.icon : Lock;
          return (
            <article
              key={b.key}
              className={`relative rounded-2xl p-4 ring-1 transition-all flex items-center gap-3 ${
                isUnlocked
                  ? `bg-gradient-to-br ${b.bg} ${b.ring} shadow-sm`
                  : "bg-slate-50 ring-slate-200"
              }`}
              data-testid={`badge-${b.key}-${isUnlocked ? "unlocked" : "locked"}`}
            >
              <div
                className={`w-11 h-11 rounded-xl flex items-center justify-center shrink-0 ${
                  isUnlocked ? `${b.iconBg} text-white shadow` : "bg-slate-200 text-slate-500"
                }`}
              >
                <Icon className="w-5 h-5" />
              </div>
              <div className="flex-1 min-w-0">
                <p className={`font-bold leading-tight ${isUnlocked ? "text-gray-900" : "text-slate-500"}`}>
                  {b.title}
                </p>
                <p className={`text-xs leading-snug ${isUnlocked ? "text-gray-700" : "text-slate-400"}`}>
                  {b.description}
                </p>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
